import { User } from '@/types/generated/graphql'

export interface RootState {
  loading: boolean
}

export interface AuthState {
  user: User
}

export type ErrorInfo = {
  code: string
  message: string
}

export interface ErrorState {
  errors?: Array<ErrorInfo>
}

export interface LoadingState {
  loading: boolean
}

export interface DrawerState {
  isOpen: boolean
}

// to be moved

export const Gender = {
  male: 1,
  female: 2,
  others: 3,
} as const
export type Gender = typeof Gender[keyof typeof Gender]
